import { render } from "./Subscription.vue?vue&type=template&id=3a3adc67"
import script from "./Subscription.vue?vue&type=script&lang=js"
export * from "./Subscription.vue?vue&type=script&lang=js"
script.render = render

export default script